<template>
  <el-dialog :visible.sync="innerVisible" title="編輯店家 Feature JSON" @close="onClose">
    <FlexLayout col :gap="20">
      <el-alert
        v-if="error"
        :title="error"
        type="error"
        show-icon
        closable
        @close="error = ''"
      />
      <el-input
        v-model="text"
        type="textarea"
        :rows="18"
        placeholder="輸入或貼上 JSON 資料"
      />

      <FlexLayout align="center" justify="end">
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="onValidate">驗證</el-button>
        <el-button type="success" @click="onSave">儲存</el-button>
      </FlexLayout>
    </FlexLayout>
  </el-dialog>
</template>

<script>
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  name: 'ShopFeatureEditor',
  props: {
    visible: { type: Boolean, default: false },
    initialData: { type: [String, Object], default: '' },
  },
  emits: ['update:visible', 'save'],
  setup (props, { emit }) {
    const innerVisible = ref(props.visible)
    const text = ref('')
    const error = ref('')

    const loadInitial = () => {
      if (typeof props.initialData === 'string') {
        text.value = props.initialData
      } else if (props.initialData && typeof props.initialData === 'object') {
        try {
          text.value = JSON.stringify(props.initialData, null, 2)
        } catch (e) {
          text.value = String(props.initialData)
        }
      } else {
        text.value = ''
      }
      error.value = ''
    }

    watch(() => props.visible, (v) => { innerVisible.value = v; if (v) loadInitial() })
    watch(innerVisible, (v) => emit('update:visible', v))

    const onClose = () => { innerVisible.value = false }

    const onValidate = () => {
      try {
        JSON.parse(text.value || '{}')
        error.value = ''
        window.$message.success('JSON 格式正確')
        // allow user to know it's valid
      } catch (e) {
        error.value = 'JSON 格式錯誤：' + e.message
      }
    }

    const onSave = () => {
      try {
        const parsed = JSON.parse(text.value || '{}')
        emit('save', parsed)
        innerVisible.value = false
      } catch (e) {
        error.value = '無法儲存，JSON 解析失敗：' + e.message
      }
    }

    // initial load when component mounted and visible
    if (props.visible) loadInitial()

    return { innerVisible, text, error, onClose, onValidate, onSave }
  },
})
</script>

<style scoped>
.el-input__inner {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, 'Roboto Mono', 'Courier New', monospace;
}
</style>
